import React from "react";
import styled from "styled-components";
import { ProjectsData } from "./ProjectsData";
function Projects() {
  return (
    <Container>
      <section>
        <h1 className="main-container project-title" id="projects">
          Projects
        </h1>

        <div className="main-container">
          <div className="project-container">
            {ProjectsData.map((item, index) => (
              <div className={`${item.ProjectDiv} project-item`} key={index}>
                <a
                  href={item.projectURL}
                  target="blank"
                  name={`project${index}`}
                >
                  <div className="project-image">
                    <img src={item.projectImage} alt="" />
                  </div>
                  <div className="project-title-info">
                    <h3 className="project-title-name">{item.projectTitle}</h3>
                    <div className="project-sub-title">
                      <p>{item.projectSubTITLE}</p>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Projects;

const Container = styled.div`
  .project-title {
    text-align: left;
    margin-bottom: 100px;
  }

  .project-title-info {
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 2vh;
    color: white;
  }

  .project-sub-title {
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    line-height: 1.65;
    color: #c6c5c6;
  }

  .project-title-name {
    color: white;
    letter-spacing: 1px;
  }

  .project-image {
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
    overflow: hidden;
  }

  .project-item:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    mix-blend-mode: multiply;
    top: 0;
    left: 0;
    background-color: var(--color-primary);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 210ms ease-in;
    pointer-events: none;
  }

  .project-item:hover::after {
    transform: scaleX(1);
    border-radius: 7px;
  }

  .project-image:hover {
    overflow: hidden;
    transform: scale(1.1, 1.1);
  }

  .project-item:hover {
    box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
  }

  .project-item {
    background: #111111;
    width: 100%;
    height: 400px;
    border-radius: 7px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    margin-top: 20px;
  }

  @media only screen and (min-width: 320px) {
    .project-container {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(10, 1fr);
      grid-row-gap: 15px;
      width: 100%;
    }

    .main-container {
      width: 90%;
    }

    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 2 / 1 / 3 / 2;
    }
    .div3 {
      grid-area: 3 / 1 / 4 / 2;
    }
    .div4 {
      grid-area: 4 / 1 / 5 / 2;
    }
    .div5 {
      grid-area: 5 / 1 / 6 / 2;
    }
    .div6 {
      grid-area: 6 / 1 / 7 / 2;
    }
    .div7 {
      grid-area: 7 / 1 / 8 / 2;
    }
    .div8 {
      grid-area: 8 / 1 / 9 / 2;
    }
    .div9 {
      grid-area: 9 / 1 / 10 / 2;
    }
    .div10 {
      grid-area: 10 / 1 / 11 / 2;
    }
  }

  @media only screen and (min-width: 780px) {
    .project-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 35px;
      grid-template-rows: repeat(5, 1fr);
      grid-row-gap: 15px;
    }

    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 1 / 2 / 2 / 3;
    }
    .div3 {
      grid-area: 2 / 1 / 3 / 2;
    }
    .div4 {
      grid-area: 2 / 2 / 3 / 3;
    }
    .div5 {
      grid-area: 3 / 1 / 4 / 2;
    }
    .div6 {
      grid-area: 3 / 2 / 4 / 3;
    }
    .div7 {
      grid-area: 4 / 1 / 5 / 2;
    }
    .div8 {
      grid-area: 4 / 2 / 5 / 3;
    }
    .div9 {
      grid-area: 5 / 1 / 6 / 2;
    }
    .div10 {
      grid-area: 5 / 2 / 6 / 3;
    }
  }

  @media only screen and (min-width: 1700px) {
    .project-container {
      display: grid;
      grid-template-columns: repeat(3, 400px);
      grid-template-rows: repeat(3, 1fr);
      grid-column-gap: 35px;
      grid-row-gap: 35px;
      justify-content: center;
    }

    .main-container {
      display: flex;
      width: 65%;
    }

    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }

    .div2 {
      grid-area: 1 / 2 / 2 / 3;
    }

    .div3 {
      grid-area: 1 / 3 / 2 / 4;
    }

    .div4 {
      grid-area: 2 / 1 / 3 / 3;
    }

    .div5 {
      grid-area: 3 / 1 / 4 / 3;
    }

    .div6 {
      grid-area: 2 / 3 / 4 / 4;
    }

    .div7 {
      grid-area: 4 / 1 / 5 / 2;
    }

    .div6 {
      grid-area: 2 / 3 / 3 / 4;
    }
    .div7 {
      grid-area: 3 / 3 / 4 / 4;
    }
    .div8 {
      grid-area: 4 / 1 / 5 / 2;
    }
    .div9 {
      grid-area: 4 / 2 / 5 / 3;
    }
    .div10 {
      grid-area: 4 / 3 / 5 / 4;
    }
  }
`;
